import { render, staticRenderFns } from "./PreviewableImage.vue?vue&type=template&id=36b4a879&scoped=true"
import script from "./PreviewableImage.vue?vue&type=script&lang=js"
export * from "./PreviewableImage.vue?vue&type=script&lang=js"
import style0 from "./PreviewableImage.vue?vue&type=style&index=0&id=36b4a879&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b4a879",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b4a879')) {
      api.createRecord('36b4a879', component.options)
    } else {
      api.reload('36b4a879', component.options)
    }
    module.hot.accept("./PreviewableImage.vue?vue&type=template&id=36b4a879&scoped=true", function () {
      api.rerender('36b4a879', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/shared/PreviewableImage.vue"
export default component.exports